<template>
  <article class="paper">
    <h1>民事起诉状</h1>
    <div class="subtitle">（民间借贷纠纷要素式）</div>
    <p>
      <strong>原告：</strong><span class="field">张某</span>，性别：<span
        class="field"
        >男</span
      >，出生年月：<span class="field">1990年1月</span>
    </p>
    <p>
      <strong>住所地：</strong><span class="field">上海市浦东新区</span
      ><strong class="ml">联系电话：</strong
      ><span class="field">138****8899</span>
    </p>
    <p>
      <strong>被告：</strong><span class="field">王某</span>，住所地：<span
        class="field"
        >上海市浦东新区</span
      >
    </p>
    <p class="section-title">一、诉讼请求</p>
    <p class="indent">1. 判令被告向原告偿还借款本金人民币180,000元；</p>
    <p class="indent">
      2. 判令被告按照双方约定的年利率6%支付借款利息至实际清偿之日止；
    </p>
    <p class="indent">3. 本案诉讼费用由被告承担。</p>
    <p class="section-title">二、案件要素</p>
    <p><strong>借款时间：</strong>2025年3月12日</p>
    <p><strong>借款金额：</strong>人民币200,000元</p>
    <p><strong>交付方式：</strong>招商银行转账</p>
    <p><strong>借款期限：</strong>6个月，约定2025年9月12日前还清</p>
    <p><strong>利息约定：</strong>年利率6%</p>
    <p><strong>已还款金额：</strong>人民币20,000元</p>
    <p><strong>尚欠本金：</strong>人民币180,000元</p>
    <p>
      <strong>催收情况：</strong
      >原告通过微信、电话多次催收，被告认可尚欠18万元并承诺还款。
    </p>
    <p>
      <strong>证据情况：</strong
      >借条、银行转账记录、微信聊天记录、已还款转账记录。
    </p>
    <p class="section-title">三、事实与理由</p>
    <p ref="factRef" class="indent">
      2025年3月12日，被告因经营资金周转需要向原告借款人民币20万元，双方签署借条并约定借款期限为6个月，年利率为6%。原告于当日通过银行转账方式向被告交付全部借款。借款到期后，被告未按约足额归还，仅于2025年11月偿还2万元。经原告多次催收，被告确认尚欠18万元，但至今未履行清偿义务。为维护原告合法权益，现依法提起诉讼，请求人民法院判如所请。
    </p>
    <p class="section-title">四、证据清单</p>
    <p>1. 借条；</p>
    <p>2. 银行转账记录；</p>
    <p>3. 微信聊天记录；</p>
    <p>4. 被告归还2万元的转账记录。</p>
    <p style="margin-top: 28px">此致</p>
    <p>上海市浦东新区人民法院</p>
    <p style="text-align: right; margin-top: 40px">具状人：张某</p>
    <p style="text-align: right">2026年9月8日</p>
  </article>
</template>

<script setup>
defineOptions({ name: "PaperPreview" });
import { ref } from "vue";

// AI 修改应用后的正文高亮（由父组件在 AiChatSide applied 事件后调用）
const factRef = ref(null);
let hlTimer = null;
const highlightFact = () => {
  const el = factRef.value;
  if (!el) return;
  el.classList.add("highlight");
  clearTimeout(hlTimer);
  hlTimer = setTimeout(() => el.classList.remove("highlight"), 2200);
};
defineExpose({ highlightFact });
</script>

<style scoped>
.paper {
  width: 730px;
  max-width: 100%;
  min-height: 1118px;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 1px 5px rgba(25, 43, 70, 0.035);
  padding: 78px 88px;
  color: #202a38;
  font-family: "SimSun", "宋体", serif;
  font-size: 16px;
  line-height: 2.02;
}
.paper h1 {
  text-align: center;
  font-size: 25px;
  margin: 0 0 8px;
  font-weight: 700;
}
.paper .subtitle {
  text-align: center;
  font-size: 16px;
  margin-bottom: 24px;
}
.paper p {
  margin: 8px 0;
}
.paper .indent {
  text-indent: 2em;
}
.paper .section-title {
  font-weight: bold;
  margin-top: 20px;
}
.paper strong.ml {
  margin-left: 26px;
}
.paper .field {
  display: inline-block;
  min-width: 90px;
  border-bottom: 1px solid #b7bfca;
  padding: 0 4px;
}
.paper .highlight {
  background: #fff2a8;
  box-shadow: 0 0 0 4px #fff2a8;
  border-radius: 2px;
}
</style>
